import { atom, selector, useRecoilTransaction_UNSTABLE } from 'recoil';
import { GetManageConsulteesRequest } from 'api';
import { Consultee } from 'types';

export const manageConsulteeActiveTab = atom<number>({
  key: 'manageConsulteeActiveTab',
  default: 0,
});
export const manageConsulteePageSizeState = atom<number>({
  key: 'manageConsulteePageSize',
  default: 10,
});

export const manageConsulteePageNumberState = atom<number>({
  key: 'manageConsulteePageNumber',
  default: 1,
});

export const manageConsulteeSearchState = atom<string>({
  key: 'manageConsulteeSearch',
  default: '',
});

export const manageConsulteeOrganisationFilterState = atom<string>({
  key: 'manageConsulteeOrganisationFilter',
  default: '',
});

export const manageConsulteeRegistrationFilterState = atom<string>({
  key: 'manageConsulteeRegistrationFilter',
  default: 'NotDeleted',
});

export const manageConsulteeSortByDescendingFilterState = atom<boolean | undefined>({
  key: 'manageConsulteeSortByDescendingFilterState',
  default: undefined,
});

export const manageConsulteeSortByColumnFilterState = atom<string>({
  key: 'manageConsulteeSortByColumnFilterState',
  default: '',
});

export const manageConsulteesRequestState = selector<GetManageConsulteesRequest>({
  key: 'manageConsulteeSearchRequest',
  get: ({ get }) => {
    const sortByDesc = get(manageConsulteeSortByDescendingFilterState);
    const sortByColumn = get(manageConsulteeSortByColumnFilterState);
    const nameOrEmailSearchText = get(manageConsulteeSearchState);

    return {
      ...(nameOrEmailSearchText && { nameOrEmailSearchText }),
      ...(get(manageConsulteeOrganisationFilterState) && {
        organisationName: get(manageConsulteeOrganisationFilterState),
      }),
      filteredByOption: get(manageConsulteeRegistrationFilterState),
      pageNumber: get(manageConsulteePageNumberState),
      pageSize: get(manageConsulteePageSizeState),
      ...(sortByColumn && {
        sortByValue: sortByColumn,
        sortBy: sortByDesc ? 'Descending' : 'Ascending',
      }),
    };
  },
});

export const useResetGetConsulteeRequestState = (): (() => void) =>
  useRecoilTransaction_UNSTABLE(({ reset }) => () => {
    reset(manageConsulteeSearchState);
    reset(manageConsulteeOrganisationFilterState);
    reset(manageConsulteeRegistrationFilterState);
    reset(manageConsulteePageNumberState);
    reset(manageConsulteePageSizeState);
    reset(manageConsulteeSortByDescendingFilterState);
    reset(manageConsulteeSortByColumnFilterState);
  });

export const manageConsulteeUploadState = atom<boolean>({
  key: 'manageConsulteeUploadState',
  default: false,
});

export const manageUserDeleteState = atom<boolean>({
  key: 'manageConsulteeDeleteState',
  default: false,
});

export const manageUserToDeleteState = atom<Consultee | undefined>({
  key: 'manageUserToDeleteState',
  default: undefined,
});
